var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2198 4.85245L12.1585 10.6261C11.461 11.126 10.5391 11.126 9.84164 10.6261L1.78025 4.85245M1.4668 5.72039C1.4668 4.99175 2.03625 4.40039 2.73791 4.40039H19.2624C19.964 4.40039 20.5335 4.99175 20.5335 5.72039V16.2804C20.5335 17.009 19.964 17.6004 19.2624 17.6004H2.73791C2.03625 17.6004 1.4668 17.009 1.4668 16.2804V5.72039ZM14.1241 9.21804L17.3553 12.32L14.1241 9.21804ZM7.87616 9.21804L4.645 12.32L7.87616 9.21804Z",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mail-logo.6595a54decaa1ba8a071f3e1fae226f3.svg";
export { ForwardRef as ReactComponent };